import { Link } from "react-router-dom";

// One line under a form's submit button.
export default function PrivacyNotice({ testid = "privacy-notice" }) {
  return (
    <p className="hs-hint m-0" data-testid={testid}>
      We keep what you send here as described in our <Link className="hs-link" to="/privacy">privacy page</Link>.
    </p>
  );
}
